export default __webpack_public_path__ + "static/media/image-ph-study-ranking-n-w@2x.3214eee0.png";